'use client';
import React, { useEffect } from 'react';

export const useLottieLoader = (lottieUrl: string | null) => {
  const [lottie, setLottie] = React.useState<object | null>(null);

  useEffect(() => {
    if (!lottieUrl) return;
    fetch(lottieUrl)
      .then(response => response.json())
      .then(data => setLottie(data))
      .catch(error => console.error(error));
  }, [lottieUrl]);

  return lottie;
};
